<template>
  <div :class="validationContainerClass">
    <v-validate
      :rules="rules"
      :vid="name"
      v-slot="{ errors, classes }"
      :name="label"
    >
      <div class="">
        <label :for="id"
          >{{ label }}
          <div v-if="isRequired" class="is-required">
            <i class="fas fa-star-of-life"></i></div
        ></label>
        <div :class="{ 'trumbowyg-dark': isDarkmode }">
          <textarea :id="name"></textarea>
        </div>
        <div v-if="showPreview" class="preview" v-html="content"></div>
        <span class="invalid-feedback">{{ errors[0] }}</span>
      </div>
    </v-validate>
  </div>
</template>
<script>
import InputCommons from "./InputCommons.vue";

export default {
  extends: InputCommons,
  props: {
    dir: {
      type: String,
      default: "texteditor",
    },
    uploadUrl: {
      type: String,
      default: "/shop/files",
    },
  },
  data() {
    return {
      isDarkmode: false,
      showPreview: false,
      editor: {},
    };
  },
  computed: {
    editorSelector() {
      return `textarea#${this.name}`;
    },
    btns() {
      return [
        ["fontsize"],
        ["fontfamily"],
        ["foreColor", "backColor"],
        ["lineheight"],
        ["justifyRight", "justifyCenter", "justifyLeft", "justifyFull"],
        ["unorderedList", "orderedList"],
        ["formatting"],
        ["strong", "em", "del"],
        ["table"],
        ["upload"],
        ["link"],
        ["insertImage"],
        ["noembed"],
        ["emoji"],
        ["undo", "redo"], // Only supported in Blink browsers
        ["superscript", "subscript"],
        ["horizontalRule"],
        ["removeformat"],
        ["viewHTML"],
        ["preview"],
        ["fullscreen"],
      ];
    },
    plugins() {
      return {
        fontsize: {
          sizeList: ["12px", "14px", "16px"],
        },
        upload: {
          data: [{ name: "dir", value: this.dir }],
          fileFieldName: "file_to_upload",
          headers: {
            "X-XSRF-TOKEN": this.$store.state.xsrfToken,
            "X-Requested-With": "XMLHttpRequest",
          },
          serverPath: `${process.env.VUE_APP_API_BASEPOINT}${this.uploadUrl}`,
          urlPropertyName: "entity",
          statusPropertyName: "is_success",
          xhrFields: {
            withCredentials: true,
          },
          // Some upload plugin options, see details below
        },
        fontfamily: {
          fontList: [
            { name: "Arial", family: "Arial, Helvetica, sans-serif" },
            { name: "Open Sans", family: "'Open Sans', sans-serif" },
          ],
        },
      };
    },
  },
  mounted() {
    // this.manageDarkmode();
    this.registrerDarkmodeEventListener();
    this.initialEditor();
  },
  watch: {
    // content() {
    //   $("textarea").trumbowyg("html", this.content);
    // },
  },
  methods: {
    setInitialValue(_value) {
      $(this.editorSelector).trumbowyg("html", _value);
    },
    reset(){
      $(this.editorSelector).trumbowyg("html", '');
    },
    initialEditor() {
      this.editor = $(this.editorSelector).trumbowyg({
        svgPath: "/img/icons.svg",
        imageWidthModalEdit: true,
        lang: "fa",
        btns: this.btns,
        plugins: this.plugins,
        btnsDef: {
          preview: {
            fn: () => {
              this.showPreview = !this.showPreview;
            },
            ico: "preview",
            title: "پیش نمایش",
            hasIcon: true,
          },
        },
      });

      this.editor.on("tbwchange", () => {
        this.content = $(this.editorSelector).trumbowyg("html");
        this.handleInput(this.content);
      });
    },
    manageDarkmode() {
      this.isDarkmode = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
    },
    registrerDarkmodeEventListener() {
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .addEventListener("change", (e) => {
          this.isDarkmode = e.matches ? true : false;
        });
    },
    removeDarkmodeEventListener() {
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .removeEventListener("change", (e) => {
          this.isDarkmode = e.matches ? true : false;
        });
    },
  },
  beforeDestroy() {
    $(this.editorSelector).trumbowyg("destroy");
    this.removeDarkmodeEventListener();
  },
};
</script>
<style scoped>
.preview {
  color: #000;
  background: #fff;
  border: 1px solid #ccc;
}
</style>
<style>
.trumbowyg-modal-box .trumbowyg-modal-button {
  font-family: "iranyekan" !important;
}

.trumbowyg-dark {
  color: #fff;
}

/* .trumbowyg-modal-box label input {
  height: 36px !important;
}

.trumbowyg-modal-box label .trumbowyg-input-infos {
  height: 63px !important;
}

.trumbowyg-modal-box label {
    height: 37px !important;
    margin: 4px 12px !important;
}

.trumbowyg-modal-box label .trumbowyg-input-infos span {
    height: 36px !important;
} */
</style>